// Retrieved from: https://gist.github.com/simzou/6459889

export default [
  {
    rank: '80',
    dma: 'Portland-Auburn',
    tv_homes: '389530',
    percent_of_usa: '0.341',
    dma_code: '500',
  },
  {
    rank: '1',
    dma: 'New York',
    tv_homes: '7384340',
    percent_of_usa: '6.468',
    dma_code: '501',
  },
  {
    rank: '157',
    dma: 'Binghamton',
    tv_homes: '133420',
    percent_of_usa: '0.117',
    dma_code: '502',
  },
  {
    rank: '120',
    dma: 'Macon',
    tv_homes: '241170',
    percent_of_usa: '0.211',
    dma_code: '503',
  },
  {
    rank: '4',
    dma: 'Philadelphia',
    tv_homes: '2949310',
    percent_of_usa: '2.583',
    dma_code: '504',
  },
  {
    rank: '11',
    dma: 'Detroit',
    tv_homes: '1845920',
    percent_of_usa: '1.617',
    dma_code: '505',
  },
  {
    rank: '7',
    dma: 'Boston (Manchester)',
    tv_homes: '2366690',
    percent_of_usa: '2.073',
    dma_code: '506',
  },
  {
    rank: '92',
    dma: 'Savannah',
    tv_homes: '334750',
    percent_of_usa: '0.293',
    dma_code: '507',
  },
  {
    rank: '23',
    dma: 'Pittsburgh',
    tv_homes: '1165740',
    percent_of_usa: '1.021',
    dma_code: '508',
  },
  {
    rank: '109',
    dma: 'Ft. Wayne',
    tv_homes: '265390',
    percent_of_usa: '0.232',
    dma_code: '509',
  },
  {
    rank: '18',
    dma: 'Cleveland-Akron (Canton)',
    tv_homes: '1485140',
    percent_of_usa: '1.301',
    dma_code: '510',
  },
  {
    rank: '8',
    dma: 'Washington, DC (Hagrstwn)',
    tv_homes: '2359160',
    percent_of_usa: '2.066',
    dma_code: '511',
  },
  {
    rank: '27',
    dma: 'Baltimore',
    tv_homes: '1085070',
    percent_of_usa: '0.950',
    dma_code: '512',
  },
  {
    rank: '67',
    dma: 'Flint-Saginaw-Bay City',
    tv_homes: '446010',
    percent_of_usa: '0.391',
    dma_code: '513',
  },
  {
    rank: '52',
    dma: 'Buffalo',
    tv_homes: '632150',
    percent_of_usa: '0.554',
    dma_code: '514',
  },
  {
    rank: '35',
    dma: 'Cincinnati',
    tv_homes: '897890',
    percent_of_usa: '0.786',
    dma_code: '515',
  },
  {
    rank: '146',
    dma: 'Erie',
    tv_homes: '155190',
    percent_of_usa: '0.136',
    dma_code: '516',
  },
  {
    rank: '25',
    dma: 'Charlotte',
    tv_homes: '1136420',
    percent_of_usa: '0.995',
    dma_code: '517',
  },
  {
    rank: '46',
    dma: 'Greensboro-H.Point-W.Salem',
    tv_homes: '695100',
    percent_of_usa: '0.609',
    dma_code: '518',
  },
  {
    rank: '98',
    dma: 'Charleston, SC',
    tv_homes: '316080',
    percent_of_usa: '0.277',
    dma_code: '519',
  },
  {
    rank: '113',
    dma: 'Augusta-Aiken',
    tv_homes: '257730',
    percent_of_usa: '0.226',
    dma_code: '520',
  },
  {
    rank: '53',
    dma: 'Providence-New Bedford',
    tv_homes: '606400',
    percent_of_usa: '0.531',
    dma_code: '521',
  },
  {
    rank: '127',
    dma: 'Columbus, GA (Opelika, AL)',
    tv_homes: '216920',
    percent_of_usa: '0.190',
    dma_code: '522',
  },
  {
    rank: '97',
    dma: 'Burlington-Plattsburgh',
    tv_homes: '316910',
    percent_of_usa: '0.278',
    dma_code: '523',
  },
  {
    rank: '9',
    dma: 'Atlanta',
    tv_homes: '2326840',
    percent_of_usa: '2.038',
    dma_code: '524',
  },
  {
    rank: '150',
    dma: 'Albany, GA',
    tv_homes: '150110',
    percent_of_usa: '0.131',
    dma_code: '525',
  },
  {
    rank: '172',
    dma: 'Utica',
    tv_homes: '102890',
    percent_of_usa: '0.090',
    dma_code: '526',
  },
  {
    rank: '26',
    dma: 'Indianapolis',
    tv_homes: '1089700',
    percent_of_usa: '0.954',
    dma_code: '527',
  },
  {
    rank: '16',
    dma: 'Miami-Ft. Lauderdale',
    tv_homes: '1621130',
    percent_of_usa: '1.420',
    dma_code: '528',
  },
  {
    rank: '48',
    dma: 'Louisville',
    tv_homes: '670880',
    percent_of_usa: '0.588',
    dma_code: '529',
  },
  {
    rank: '106',
    dma: 'Tallahassee-Thomasville',
    tv_homes: '273120',
    percent_of_usa: '0.239',
    dma_code: '530',
  },
  {
    rank: '96',
    dma: 'Tri-Cities, TN-VA',
    tv_homes: '319060',
    percent_of_usa: '0.279',
    dma_code: '531',
  },
  {
    rank: '58',
    dma: 'Albany-Schenectady-Troy',
    tv_homes: '540050',
    percent_of_usa: '0.473',
    dma_code: '532',
  },
  {
    rank: '30',
    dma: 'Hartford & New Haven',
    tv_homes: '996550',
    percent_of_usa: '0.873',
    dma_code: '533',
  },
  {
    rank: '19',
    dma: 'Orlando-Daytona Bch-Melbrn',
    tv_homes: '1453170',
    percent_of_usa: '1.273',
    dma_code: '534',
  },
  {
    rank: '32',
    dma: 'Columbus, OH',
    tv_homes: '930460',
    percent_of_usa: '0.815',
    dma_code: '535',
  },
  {
    rank: '110',
    dma: 'Youngstown',
    tv_homes: '260000',
    percent_of_usa: '0.228',
    dma_code: '536',
  },
  {
    rank: '155',
    dma: 'Bangor',
    tv_homes: '138040',
    percent_of_usa: '0.121',
    dma_code: '537',
  },
  {
    rank: '78',
    dma: 'Rochester, NY',
    tv_homes: '395680',
    percent_of_usa: '0.347',
    dma_code: '538',
  },
  {
    rank: '14',
    dma: 'Tampa-St. Pete (Sarasota)',
    tv_homes: '1806560',
    percent_of_usa: '1.582',
    dma_code: '539',
  },
  {
    rank: '119',
    dma: 'Traverse City-Cadillac',
    tv_homes: '241800',
    percent_of_usa: '0.212',
    dma_code: '540',
  },
  {
    rank: '64',
    dma: 'Lexington',
    tv_homes: '485630',
    percent_of_usa: '0.425',
    dma_code: '541',
  },
  {
    rank: '63',
    dma: 'Dayton',
    tv_homes: '498270',
    percent_of_usa: '0.436',
    dma_code: '542',
  },
  {
    rank: '114',
    dma: 'Springfield-Holyoke',
    tv_homes: '252950',
    percent_of_usa: '0.222',
    dma_code: '543',
  },
  {
    rank: '44',
    dma: 'Norfolk-Portsmth-Newpt Nws',
    tv_homes: '709730',
    percent_of_usa: '0.622',
    dma_code: '544',
  },
  {
    rank: '100',
    dma: 'Greenville-N.Bern-Washngtn',
    tv_homes: '303280',
    percent_of_usa: '0.266',
    dma_code: '545',
  },
  {
    rank: '77',
    dma: 'Columbia, SC',
    tv_homes: '398510',
    percent_of_usa: '0.349',
    dma_code: '546',
  },
  {
    rank: '76',
    dma: 'Toledo',
    tv_homes: '409550',
    percent_of_usa: '0.359',
    dma_code: '547',
  },
  {
    rank: '38',
    dma: 'West Palm Beach-Ft. Pierce',
    tv_homes: '794310',
    percent_of_usa: '0.696',
    dma_code: '548',
  },
  {
    rank: '177',
    dma: 'Watertown',
    tv_homes: '92590',
    percent_of_usa: '0.081',
    dma_code: '549',
  },
  {
    rank: '132',
    dma: 'Wilmington',
    tv_homes: '188420',
    percent_of_usa: '0.165',
    dma_code: '550',
  },
  {
    rank: '115',
    dma: 'Lansing',
    tv_homes: '251140',
    percent_of_usa: '0.220',
    dma_code: '551',
  },
  {
    rank: '205',
    dma: 'Presque Isle',
    tv_homes: '29250',
    percent_of_usa: '0.026',
    dma_code: '552',
  },
  {
    rank: '180',
    dma: 'Marquette',
    tv_homes: '84640',
    percent_of_usa: '0.074',
    dma_code: '553',
  },
  {
    rank: '158',
    dma: 'Wheeling-Steubenville',
    tv_homes: '130110',
    percent_of_usa: '0.114',
    dma_code: '554',
  },
  {
    rank: '84',
    dma: 'Syracuse',
    tv_homes: '377550',
    percent_of_usa: '0.331',
    dma_code: '555',
  },
  {
    rank: '57',
    dma: 'Richmond-Petersburg',
    tv_homes: '553390',
    percent_of_usa: '0.485',
    dma_code: '556',
  },
  {
    rank: '61',
    dma: 'Knoxville',
    tv_homes: '520890',
    percent_of_usa: '0.456',
    dma_code: '557',
  },
  {
    rank: '199',
    dma: 'Lima',
    tv_homes: '51240',
    percent_of_usa: '0.045',
    dma_code: '558',
  },
  {
    rank: '156',
    dma: 'Bluefield-Beckley-Oak Hill',
    tv_homes: '134410',
    percent_of_usa: '0.118',
    dma_code: '559',
  },
  {
    rank: '24',
    dma: 'Raleigh-Durham (Fayetvlle)',
    tv_homes: '1150350',
    percent_of_usa: '1.008',
    dma_code: '560',
  },
  {
    rank: '50',
    dma: 'Jacksonville',
    tv_homes: '659170',
    percent_of_usa: '0.577',
    dma_code: '561',
  },
  {
    rank: '39',
    dma: 'Grand Rapids-Kalmzoo-B.Crk',
    tv_homes: '720150',
    percent_of_usa: '0.631',
    dma_code: '563',
  },
  {
    rank: '65',
    dma: 'Charleston-Huntington',
    tv_homes: '455490',
    percent_of_usa: '0.399',
    dma_code: '564',
  },
  {
    rank: '174',
    dma: 'Elmira (Corning)',
    tv_homes: '95530',
    percent_of_usa: '0.084',
    dma_code: '565',
  },
  {
    rank: '43',
    dma: 'Harrisburg-Lncstr-Leb-York',
    tv_homes: '716990',
    percent_of_usa: '0.628',
    dma_code: '566',
  },
  {
    rank: '37',
    dma: 'Greenvll-Spart-Ashevll-And',
    tv_homes: '846030',
    percent_of_usa: '0.741',
    dma_code: '567',
  },
  {
    rank: '178',
    dma: 'Harrisonburg',
    tv_homes: '90260',
    percent_of_usa: '0.079',
    dma_code: '569',
  },
  {
    rank: '103',
    dma: 'Myrtle Beach-Florence',
    tv_homes: '285550',
    percent_of_usa: '0.250',
    dma_code: '570',
  },
  {
    rank: '62',
    dma: 'Ft. Myers-Naples',
    tv_homes: '502050',
    percent_of_usa: '0.440',
    dma_code: '571',
  },
  {
    rank: '68',
    dma: 'Roanoke-Lynchburg',
    tv_homes: '445470',
    percent_of_usa: '0.390',
    dma_code: '573',
  },
  {
    rank: '102',
    dma: 'Johnstown-Altoona-St Colge',
    tv_homes: '288100',
    percent_of_usa: '0.252',
    dma_code: '574',
  },
  {
    rank: '87',
    dma: 'Chattanooga',
    tv_homes: '353710',
    percent_of_usa: '0.310',
    dma_code: '575',
  },
  {
    rank: '144',
    dma: 'Salisbury',
    tv_homes: '157830',
    percent_of_usa: '0.138',
    dma_code: '576',
  },
  {
    rank: '54',
    dma: 'Wilkes Barre-Scranton-Hztn',
    tv_homes: '581020',
    percent_of_usa: '0.509',
    dma_code: '577',
  },
  {
    rank: '154',
    dma: 'Terre Haute',
    tv_homes: '139600',
    percent_of_usa: '0.122',
    dma_code: '581',
  },
  {
    rank: '189',
    dma: 'Lafayette, IN',
    tv_homes: '66240',
    percent_of_usa: '0.058',
    dma_code: '582',
  },
  {
    rank: '208',
    dma: 'Alpena',
    tv_homes: '16910',
    percent_of_usa: '0.015',
    dma_code: '583',
  },
  {
    rank: '183',
    dma: 'Charlottesville',
    tv_homes: '74340',
    percent_of_usa: '0.065',
    dma_code: '584',
  },
  {
    rank: '95',
    dma: 'South Bend-Elkhart',
    tv_homes: '319860',
    percent_of_usa: '0.280',
    dma_code: '588',
  },
  {
    rank: '163',
    dma: 'Gainesville',
    tv_homes: '123430',
    percent_of_usa: '0.108',
    dma_code: '592',
  },
  {
    rank: '203',
    dma: 'Zanesville',
    tv_homes: '32940',
    percent_of_usa: '0.029',
    dma_code: '596',
  },
  {
    rank: '193',
    dma: 'Parkersburg',
    tv_homes: '62620',
    percent_of_usa: '0.055',
    dma_code: '597',
  },
  {
    rank: '170',
    dma: 'Clarksburg-Weston',
    tv_homes: '106480',
    percent_of_usa: '0.093',
    dma_code: '598',
  },
  {
    rank: '129',
    dma: 'Corpus Christi',
    tv_homes: '203730',
    percent_of_usa: '0.178',
    dma_code: '600',
  },
  {
    rank: '3',
    dma: 'Chicago',
    tv_homes: '3484800',
    percent_of_usa: '3.052',
    dma_code: '602',
  },
  {
    rank: '149',
    dma: 'Joplin-Pittsburg',
    tv_homes: '151200',
    percent_of_usa: '0.132',
    dma_code: '603',
  },
  {
    rank: '138',
    dma: 'Columbia-Jefferson City',
    tv_homes: '173640',
    percent_of_usa: '0.152',
    dma_code: '604',
  },
  {
    rank: '136',
    dma: 'Topeka',
    tv_homes: '176160',
    percent_of_usa: '0.154',
    dma_code: '605',
  },
  {
    rank: '169',
    dma: 'Dothan',
    tv_homes: '107110',
    percent_of_usa: '0.094',
    dma_code: '606',
  },
  {
    rank: '21',
    dma: 'St. Louis',
    tv_homes: '1243490',
    percent_of_usa: '1.089',
    dma_code: '609',
  },
  {
    rank: '135',
    dma: 'Rockford',
    tv_homes: '179240',
    percent_of_usa: '0.157',
    dma_code: '610',
  },
  {
    rank: '153',
    dma: 'Rochestr-Mason City-Austin',
    tv_homes: '143330',
    percent_of_usa: '0.126',
    dma_code: '611',
  },
  {
    rank: '82',
    dma: 'Shreveport',
    tv_homes: '384410',
    percent_of_usa: '0.337',
    dma_code: '612',
  },
  {
    rank: '15',
    dma: 'Minneapolis-St. Paul',
    tv_homes: '1728050',
    percent_of_usa: '1.513',
    dma_code: '613',
  },
  {
    rank: '31',
    dma: 'Kansas City',
    tv_homes: '931320',
    percent_of_usa: '0.816',
    dma_code: '616',
  },
  {
    rank: '34',
    dma: 'Milwaukee',
    tv_homes: '902190',
    percent_of_usa: '0.790',
    dma_code: '617',
  },
  {
    rank: '10',
    dma: 'Houston',
    tv_homes: '2215650',
    percent_of_usa: '1.941',
    dma_code: '618',
  },
  {
    rank: '74',
    dma: 'Springfield, MO',
    tv_homes: '414570',
    percent_of_usa: '0.363',
    dma_code: '619',
  },
  {
    rank: '51',
    dma: 'New Orleans',
    tv_homes: '641550',
    percent_of_usa: '0.562',
    dma_code: '622',
  },
  {
    rank: '5',
    dma: 'Dallas-Ft. Worth',
    tv_homes: '2588020',
    percent_of_usa: '2.267',
    dma_code: '623',
  },
  {
    rank: '147',
    dma: 'Sioux City',
    tv_homes: '154830',
    percent_of_usa: '0.136',
    dma_code: '624',
  },
  {
    rank: '88',
    dma: 'Waco-Temple-Bryan',
    tv_homes: '349540',
    percent_of_usa: '0.306',
    dma_code: '625',
  },
  {
    rank: '204',
    dma: 'Victoria',
    tv_homes: '31560',
    percent_of_usa: '0.028',
    dma_code: '626',
  },
  {
    rank: '143',
    dma: 'Wichita Falls & Lawton',
    tv_homes: '158500',
    percent_of_usa: '0.139',
    dma_code: '627',
  },
  {
    rank: '137',
    dma: 'Monroe-El Dorado',
    tv_homes: '175960',
    percent_of_usa: '0.154',
    dma_code: '628',
  },
  {
    rank: '42',
    dma: 'Birmingham (Ann and Tusc)',
    tv_homes: '717530',
    percent_of_usa: '0.628',
    dma_code: '630',
  },
  {
    rank: '200',
    dma: 'Ottumwa-Kirksville',
    tv_homes: '46730',
    percent_of_usa: '0.041',
    dma_code: '631',
  },
  {
    rank: '81',
    dma: 'Paducah-Cape Girard-Harsbg',
    tv_homes: '388340',
    percent_of_usa: '0.340',
    dma_code: '632',
  },
  {
    rank: '152',
    dma: 'Odessa-Midland',
    tv_homes: '147730',
    percent_of_usa: '0.129',
    dma_code: '633',
  },
  {
    rank: '130',
    dma: 'Amarillo',
    tv_homes: '197110',
    percent_of_usa: '0.173',
    dma_code: '634',
  },
  {
    rank: '45',
    dma: 'Austin',
    tv_homes: '705280',
    percent_of_usa: '0.618',
    dma_code: '635',
  },
  {
    rank: '86',
    dma: 'Harlingen-Wslco-Brnsvl-McA',
    tv_homes: '364160',
    percent_of_usa: '0.319',
    dma_code: '636',
  },
  {
    rank: '90',
    dma: 'Cedar Rapids-Wtrlo-IWC&Dub',
    tv_homes: '342610',
    percent_of_usa: '0.300',
    dma_code: '637',
  },
  {
    rank: '201',
    dma: 'St. Joseph',
    tv_homes: '46180',
    percent_of_usa: '0.040',
    dma_code: '638',
  },
  {
    rank: '176',
    dma: 'Jackson, TN',
    tv_homes: '93090',
    percent_of_usa: '0.081',
    dma_code: '639',
  },
  {
    rank: '49',
    dma: 'Memphis',
    tv_homes: '662830',
    percent_of_usa: '0.581',
    dma_code: '640',
  },
  {
    rank: '36',
    dma: 'San Antonio',
    tv_homes: '881050',
    percent_of_usa: '0.772',
    dma_code: '641',
  },
  {
    rank: '124',
    dma: 'Lafayette, LA',
    tv_homes: '229320',
    percent_of_usa: '0.201',
    dma_code: '642',
  },
  {
    rank: '175',
    dma: 'Lake Charles',
    tv_homes: '94610',
    percent_of_usa: '0.083',
    dma_code: '643',
  },
  {
    rank: '179',
    dma: 'Alexandria, LA',
    tv_homes: '89280',
    percent_of_usa: '0.078',
    dma_code: '644',
  },
  {
    rank: '188',
    dma: 'Greenwood-Greenville',
    tv_homes: '66410',
    percent_of_usa: '0.058',
    dma_code: '647',
  },
  {
    rank: '83',
    dma: 'Champaign&Sprngfld-Decatur',
    tv_homes: '378720',
    percent_of_usa: '0.332',
    dma_code: '648',
  },
  {
    rank: '104',
    dma: 'Evansville',
    tv_homes: '284040',
    percent_of_usa: '0.249',
    dma_code: '649',
  },
  {
    rank: '41',
    dma: 'Oklahoma City',
    tv_homes: '718770',
    percent_of_usa: '0.630',
    dma_code: '650',
  },
  {
    rank: '142',
    dma: 'Lubbock',
    tv_homes: '159840',
    percent_of_usa: '0.140',
    dma_code: '651',
  },
  {
    rank: '75',
    dma: 'Omaha',
    tv_homes: '414060',
    percent_of_usa: '0.363',
    dma_code: '652',
  },
  {
    rank: '159',
    dma: 'Panama City',
    tv_homes: '129390',
    percent_of_usa: '0.113',
    dma_code: '656',
  },
  {
    rank: '161',
    dma: 'Sherman-Ada',
    tv_homes: '126930',
    percent_of_usa: '0.111',
    dma_code: '657',
  },
  {
    rank: '69',
    dma: 'Green Bay-Appleton',
    tv_homes: '441800',
    percent_of_usa: '0.387',
    dma_code: '658',
  },
  {
    rank: '29',
    dma: 'Nashville',
    tv_homes: '1014910',
    percent_of_usa: '0.889',
    dma_code: '659',
  },
  {
    rank: '196',
    dma: 'San Angelo',
    tv_homes: '55820',
    percent_of_usa: '0.049',
    dma_code: '661',
  },
  {
    rank: '164',
    dma: 'Abilene-Sweetwater',
    tv_homes: '114080',
    percent_of_usa: '0.100',
    dma_code: '662',
  },
  {
    rank: '85',
    dma: 'Madison',
    tv_homes: '376670',
    percent_of_usa: '0.330',
    dma_code: '669',
  },
  {
    rank: '101',
    dma: 'Ft. Smith-Fay-Sprngdl-Rgrs',
    tv_homes: '297590',
    percent_of_usa: '0.261',
    dma_code: '670',
  },
  {
    rank: '59',
    dma: 'Tulsa',
    tv_homes: '526960',
    percent_of_usa: '0.462',
    dma_code: '671',
  },
  {
    rank: '133',
    dma: 'Columbus-Tupelo-W Pnt-Hstn',
    tv_homes: '184990',
    percent_of_usa: '0.162',
    dma_code: '673',
  },
  {
    rank: '116',
    dma: 'Peoria-Bloomington',
    tv_homes: '244050',
    percent_of_usa: '0.214',
    dma_code: '675',
  },
  {
    rank: '139',
    dma: 'Duluth-Superior',
    tv_homes: '169610',
    percent_of_usa: '0.149',
    dma_code: '676',
  },
  {
    rank: '66',
    dma: 'Wichita-Hutchinson Plus',
    tv_homes: '450300',
    percent_of_usa: '0.394',
    dma_code: '678',
  },
  {
    rank: '72',
    dma: 'Des Moines-Ames',
    tv_homes: '427860',
    percent_of_usa: '0.375',
    dma_code: '679',
  },
  {
    rank: '99',
    dma: 'Davenport-R.Island-Moline',
    tv_homes: '303800',
    percent_of_usa: '0.266',
    dma_code: '682',
  },
  {
    rank: '60',
    dma: 'Mobile-Pensacola (Ft Walt)',
    tv_homes: '525990',
    percent_of_usa: '0.461',
    dma_code: '686',
  },
  {
    rank: '151',
    dma: 'Minot-Bsmrck-Dcknsn(Wlstn)',
    tv_homes: '150000',
    percent_of_usa: '0.131',
    dma_code: '687',
  },
  {
    rank: '79',
    dma: 'Huntsville-Decatur (Flor)',
    tv_homes: '390590',
    percent_of_usa: '0.342',
    dma_code: '691',
  },
  {
    rank: '141',
    dma: 'Beaumont-Port Arthur',
    tv_homes: '167110',
    percent_of_usa: '0.146',
    dma_code: '692',
  },
  {
    rank: '56',
    dma: 'Little Rock-Pine Bluff',
    tv_homes: '561760',
    percent_of_usa: '0.492',
    dma_code: '693',
  },
  {
    rank: '118',
    dma: 'Montgomery-Selma',
    tv_homes: '241930',
    percent_of_usa: '0.212',
    dma_code: '698',
  },
  {
    rank: '128',
    dma: 'La Crosse-Eau Claire',
    tv_homes: '211670',
    percent_of_usa: '0.185',
    dma_code: '702',
  },
  {
    rank: '134',
    dma: 'Wausau-Rhinelander',
    tv_homes: '179450',
    percent_of_usa: '0.157',
    dma_code: '705',
  },
  {
    rank: '107',
    dma: 'Tyler-Longview(Lfkn&Ncgd)',
    tv_homes: '268150',
    percent_of_usa: '0.235',
    dma_code: '709',
  },
  {
    rank: '167',
    dma: 'Hattiesburg-Laurel',
    tv_homes: '109950',
    percent_of_usa: '0.096',
    dma_code: '710',
  },
  {
    rank: '186',
    dma: 'Meridian',
    tv_homes: '68860',
    percent_of_usa: '0.060',
    dma_code: '711',
  },
  {
    rank: '94',
    dma: 'Baton Rouge',
    tv_homes: '329620',
    percent_of_usa: '0.289',
    dma_code: '716',
  },
  {
    rank: '171',
    dma: 'Quincy-Hannibal-Keokuk',
    tv_homes: '103520',
    percent_of_usa: '0.091',
    dma_code: '717',
  },
  {
    rank: '93',
    dma: 'Jackson, MS',
    tv_homes: '331500',
    percent_of_usa: '0.290',
    dma_code: '718',
  },
  {
    rank: '105',
    dma: 'Lincoln & Hastings-Krny',
    tv_homes: '276790',
    percent_of_usa: '0.242',
    dma_code: '722',
  },
  {
    rank: '117',
    dma: 'Fargo-Valley City',
    tv_homes: '243890',
    percent_of_usa: '0.214',
    dma_code: '724',
  },
  {
    rank: '112',
    dma: 'Sioux Falls(Mitchell)',
    tv_homes: '258460',
    percent_of_usa: '0.226',
    dma_code: '725',
  },
  {
    rank: '181',
    dma: 'Jonesboro',
    tv_homes: '80740',
    percent_of_usa: '0.071',
    dma_code: '734',
  },
  {
    rank: '182',
    dma: 'Bowling Green',
    tv_homes: '78780',
    percent_of_usa: '0.069',
    dma_code: '736',
  },
  {
    rank: '198',
    dma: 'Mankato',
    tv_homes: '52530',
    percent_of_usa: '0.046',
    dma_code: '737',
  },
  {
    rank: '209',
    dma: 'North Platte',
    tv_homes: '14720',
    percent_of_usa: '0.013',
    dma_code: '740',
  },
  {
    rank: '145',
    dma: 'Anchorage',
    tv_homes: '156280',
    percent_of_usa: '0.137',
    dma_code: '743',
  },
  {
    rank: '71',
    dma: 'Honolulu',
    tv_homes: '437790',
    percent_of_usa: '0.383',
    dma_code: '744',
  },
  {
    rank: '202',
    dma: 'Fairbanks',
    tv_homes: '37920',
    percent_of_usa: '0.033',
    dma_code: '745',
  },
  {
    rank: '160',
    dma: 'Biloxi-Gulfport',
    tv_homes: '128300',
    percent_of_usa: '0.112',
    dma_code: '746',
  },
  {
    rank: '207',
    dma: 'Juneau',
    tv_homes: '26320',
    percent_of_usa: '0.023',
    dma_code: '747',
  },
  {
    rank: '184',
    dma: 'Laredo',
    tv_homes: '72590',
    percent_of_usa: '0.064',
    dma_code: '749',
  },
  {
    rank: '17',
    dma: 'Denver',
    tv_homes: '1566460',
    percent_of_usa: '1.372',
    dma_code: '751',
  },
  {
    rank: '89',
    dma: 'Colorado Springs-Pueblo',
    tv_homes: '343990',
    percent_of_usa: '0.301',
    dma_code: '752',
  },
  {
    rank: '13',
    dma: 'Phoenix (Prescott)',
    tv_homes: '1812040',
    percent_of_usa: '1.587',
    dma_code: '753',
  },
  {
    rank: '187',
    dma: 'Butte-Bozeman',
    tv_homes: '67180',
    percent_of_usa: '0.059',
    dma_code: '754',
  },
  {
    rank: '190',
    dma: 'Great Falls',
    tv_homes: '65930',
    percent_of_usa: '0.058',
    dma_code: '755',
  },
  {
    rank: '168',
    dma: 'Billings',
    tv_homes: '109730',
    percent_of_usa: '0.096',
    dma_code: '756',
  },
  {
    rank: '111',
    dma: 'Boise',
    tv_homes: '259090',
    percent_of_usa: '0.227',
    dma_code: '757',
  },
  {
    rank: '162',
    dma: 'Idaho Fals-Pocatllo(Jcksn)',
    tv_homes: '125710',
    percent_of_usa: '0.110',
    dma_code: '758',
  },
  {
    rank: '195',
    dma: 'Cheyenne-Scottsbluff',
    tv_homes: '56350',
    percent_of_usa: '0.049',
    dma_code: '759',
  },
  {
    rank: '191',
    dma: 'Twin Falls',
    tv_homes: '64100',
    percent_of_usa: '0.056',
    dma_code: '760',
  },
  {
    rank: '166',
    dma: 'Missoula',
    tv_homes: '113010',
    percent_of_usa: '0.099',
    dma_code: '762',
  },
  {
    rank: '173',
    dma: 'Rapid City',
    tv_homes: '98020',
    percent_of_usa: '0.086',
    dma_code: '764',
  },
  {
    rank: '91',
    dma: 'El Paso (Las Cruces)',
    tv_homes: '339130',
    percent_of_usa: '0.297',
    dma_code: '765',
  },
  {
    rank: '206',
    dma: 'Helena',
    tv_homes: '28260',
    percent_of_usa: '0.025',
    dma_code: '766',
  },
  {
    rank: '197',
    dma: 'Casper-Riverton',
    tv_homes: '55270',
    percent_of_usa: '0.048',
    dma_code: '767',
  },
  {
    rank: '33',
    dma: 'Salt Lake City',
    tv_homes: '917370',
    percent_of_usa: '0.803',
    dma_code: '770',
  },
  {
    rank: '165',
    dma: 'Yuma-El Centro',
    tv_homes: '113230',
    percent_of_usa: '0.099',
    dma_code: '771',
  },
  {
    rank: '185',
    dma: 'Grand Junction-Montrose',
    tv_homes: '70580',
    percent_of_usa: '0.062',
    dma_code: '773',
  },
  {
    rank: '70',
    dma: 'Tucson (Sierra Vista)',
    tv_homes: '438440',
    percent_of_usa: '0.384',
    dma_code: '789',
  },
  {
    rank: '47',
    dma: 'Albuquerque-Santa Fe',
    tv_homes: '691450',
    percent_of_usa: '0.606',
    dma_code: '790',
  },
  {
    rank: '210',
    dma: 'Glendive',
    tv_homes: '4050',
    percent_of_usa: '0.004',
    dma_code: '798',
  },
  {
    rank: '126',
    dma: 'Bakersfield',
    tv_homes: '221740',
    percent_of_usa: '0.194',
    dma_code: '800',
  },
  {
    rank: '121',
    dma: 'Eugene',
    tv_homes: '235570',
    percent_of_usa: '0.206',
    dma_code: '801',
  },
  {
    rank: '194',
    dma: 'Eureka',
    tv_homes: '59610',
    percent_of_usa: '0.052',
    dma_code: '802',
  },
  {
    rank: '2',
    dma: 'Los Angeles',
    tv_homes: '5613460',
    percent_of_usa: '4.917',
    dma_code: '803',
  },
  {
    rank: '148',
    dma: 'Palm Springs',
    tv_homes: '154560',
    percent_of_usa: '0.135',
    dma_code: '804',
  },
  {
    rank: '6',
    dma: 'San Francisco-Oak-San Jose',
    tv_homes: '2502030',
    percent_of_usa: '2.191',
    dma_code: '807',
  },
  {
    rank: '122',
    dma: 'Yakima-Pasco-Rchlnd-Knnwck',
    tv_homes: '231950',
    percent_of_usa: '0.203',
    dma_code: '810',
  },
  {
    rank: '108',
    dma: 'Reno',
    tv_homes: '265600',
    percent_of_usa: '0.233',
    dma_code: '811',
  },
  {
    rank: '140',
    dma: 'Medford-Klamath Falls',
    tv_homes: '167820',
    percent_of_usa: '0.147',
    dma_code: '813',
  },
  {
    rank: '12',
    dma: 'Seattle-Tacoma',
    tv_homes: '1818900',
    percent_of_usa: '1.593',
    dma_code: '819',
  },
  {
    rank: '22',
    dma: 'Portland, OR',
    tv_homes: '1182180',
    percent_of_usa: '1.035',
    dma_code: '820',
  },
  {
    rank: '192',
    dma: 'Bend, OR',
    tv_homes: '62950',
    percent_of_usa: '0.055',
    dma_code: '821',
  },
  {
    rank: '28',
    dma: 'San Diego',
    tv_homes: '1075120',
    percent_of_usa: '0.942',
    dma_code: '825',
  },
  {
    rank: '125',
    dma: 'Monterey-Salinas',
    tv_homes: '224240',
    percent_of_usa: '0.196',
    dma_code: '828',
  },
  {
    rank: '40',
    dma: 'Las Vegas',
    tv_homes: '718990',
    percent_of_usa: '0.630',
    dma_code: '839',
  },
  {
    rank: '122',
    dma: 'SantaBarbra-SanMar-SanLuOb',
    tv_homes: '231950',
    percent_of_usa: '0.203',
    dma_code: '855',
  },
  {
    rank: '20',
    dma: 'Sacramnto-Stkton-Modesto',
    tv_homes: '1387710',
    percent_of_usa: '1.215',
    dma_code: '862',
  },
  {
    rank: '55',
    dma: 'Fresno-Visalia',
    tv_homes: '576820',
    percent_of_usa: '0.505',
    dma_code: '866',
  },
  {
    rank: '131',
    dma: 'Chico-Redding',
    tv_homes: '191500',
    percent_of_usa: '0.168',
    dma_code: '868',
  },
  {
    rank: '73',
    dma: 'Spokane',
    tv_homes: '420640',
    percent_of_usa: '0.368',
    dma_code: '881',
  },
]
